import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:teamId/inventory-report',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/InventoryReportsContainer',
      './modules/InventoryReports'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const InventoryReports = require('./containers/InventoryReportsContainer').default
      const actions = require('./modules/InventoryReports')
      const reducer = require('./modules/InventoryReports').default
      const auth = require('components/Auth')

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'inventoryReports', reducer: reducer })

      store.dispatch(auth.addStorageListener())
      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchData(nextState.params.id, nextState.params.teamId))

      /*  Return getComponent   */
      cb(null, InventoryReports)

    /* Webpack named bundle   */
    }, 'InventoryReports')
  }
})



// WEBPACK FOOTER //
// ./src/routes/InventoryReportsList/index.js